import { render, staticRenderFns } from "./ReportsManufacturer.vue?vue&type=template&id=444df28a&"
import script from "./ReportsManufacturer.vue?vue&type=script&lang=js&"
export * from "./ReportsManufacturer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports